// Locales are defined in i18n/routing via defineRouting
export const APP_LOCALES = ['en'] // Add more locales when LOCALIZATION_ENABLED is set to true (['en', 'es', 'fr', 'de'])
export const APP_DEFAULT_LOCALE = 'en'

export const LOCALE_TRANSLATION = {
	en: 'English',
	es: 'Español',
	fr: 'Français',
	de: 'Deutsch',
}
